import React, { FC, useState } from 'react';
import { Button, Dropdown } from 'antd';
import { TriangleUpIcon } from 'components/Elements/CustomSVGIcon';
import './exportDropdown.scss';

interface ExportDropdownProps {
    onExport: () => void;
    buttonLabel?: string;
    disabled?: boolean;
}

const items = [
    { key: 'csv', label: 'CSV' },
];

const ExportDropdown: FC<ExportDropdownProps> = ({
    onExport,
    buttonLabel = 'Export Incidents',
    disabled = false,
}) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    return (
        <div className="filter-button-container">
            <Dropdown
                menu={{
                    items,
                    onClick: () => onExport(),
                }}
                trigger={['click']}
                placement="bottomRight"
                disabled={disabled}
                onOpenChange={(open) => setIsDropdownOpen(open)}
                overlayClassName="export-dropdown-overlay">
                <Button type="primary" className="export-button" style={{ height: 45 }} disabled={disabled}>
                    {buttonLabel}
                    <span
                        className="export-button-icon"
                        style={{ transform: isDropdownOpen ? 'rotate(0deg)' : 'rotate(180deg)' }}>
                        <TriangleUpIcon w={20} h={10} />
                    </span>
                </Button>
            </Dropdown>
        </div>
    );
};

ExportDropdown.defaultProps = {
    buttonLabel: 'Export Incidents',
    disabled: false,
};

export default ExportDropdown;
